import { useQuery } from '@tanstack/react-query';

import { postData } from 'src/app/queries';

import { marketingCampaignsQueryKey, type GetCampaignV2Response, type SavedMarketingCampaign } from './get-campaigns';

type GetSavedCampaignPayload = {
  MarketingCampaignId: number | null;
};

export function useGetMarketingCampaignQuery({ marketingCampaignId }: { marketingCampaignId: number | null }) {
  return useQuery({
    queryKey: [...marketingCampaignsQueryKey, 'saved-campaign', marketingCampaignId],
    enabled: !!marketingCampaignId,
    staleTime: 0,
    queryFn: async () =>
      postData<GetSavedCampaignPayload, SavedMarketingCampaign>({
        endpoint: 'api/marketing-campaign/get-campaign',
        payload: { MarketingCampaignId: marketingCampaignId },
      }),
  });
}

export function useGetMarketingCampaignV2Query({ marketingCampaignId }: { marketingCampaignId: number | null }) {
  return useQuery({
    queryKey: [...marketingCampaignsQueryKey, 'saved-campaign-v2', marketingCampaignId],
    enabled: !!marketingCampaignId,
    staleTime: 0,
    queryFn: async () =>
      postData<GetSavedCampaignPayload, GetCampaignV2Response>({
        endpoint: 'api/marketing-campaign/get-campaign-v2',
        payload: { MarketingCampaignId: marketingCampaignId },
      }),
  });
}
